require("./brokerCryptoModalFooter.scss");
// @vendors
import React from "react";
const { FormattedText } = require('core/i18n').i18n;
// @components
import { CryptoButton } from "../../../../brokerCryptoButton/brokerCryptoButton";

const CryptoModalFooter = ({ onPrimaryButtonClick }) => (
    <div className="crypto-modal-footer__container">
        <CryptoButton type='primary' onClick={onPrimaryButtonClick}>
            <FormattedText value="broker-convenienceMifidSuccessContinueCTA" />
        </CryptoButton>
    </div>
);

export { CryptoModalFooter };
